import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useDispatch, useSelector } from "react-redux";
import Employee from "~/pages/Employee";
import { SeccondModalButtons } from "./styles";

export default function EmployeeModal(props) {
  const dispatch = useDispatch();
  const activeModal = useSelector((state) => state.orderReducer.activeModal);
  const [showSecondModal, setShowSecondModal] = useState(false);
  const [showModal, setShowModal] = useState(true);

  useEffect(() => {
    setShowModal(true);
  }, [activeModal]);

  return (
    <>
      <Modal
        show={showSecondModal}
        onHide={() => {
          setShowSecondModal(true);
        }}
      >
        <Modal.Body>
          <div>
            <div>
              <span>Tem certeza que deseja fechar o cadastro?</span>
            </div>
            <SeccondModalButtons>
              <Button
                style={{ marginRight: ".7rem", padding: "0 1rem" }}
                variant="secondary"
                onClick={() => {
                  setShowSecondModal(false);
                  dispatch({ 
                    type: "ACTIVE_EMPLOYEE_MODAL", 
                    activeModal: { employee: false, modal: false }
                  });
                }}
              >
                Sim
              </Button>
              <Button
                variant="primary"
                onClick={() => setShowSecondModal(false)}
                style={{ marginRight: ".7rem", padding: "0 1rem" }}
              >
                Não
              </Button>
            </SeccondModalButtons>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showModal}
        onHide={() => {
          setShowSecondModal(true);
        }}
        centered
        className="employee-modal"
      >
        <Modal.Body style={{ padding: 0 }}>
          <div style={{ overflow: "scroll" }}>
            <Employee desktop={true} />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
